var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3671_10344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 12.0729C23.9991 5.40393 18.6261 -0.0020752 11.9991 -0.0020752C5.36909 -0.000575195 -0.00390625 5.40393 -0.00390625 12.0744C-0.00390625 18.0999 4.38509 23.0949 10.1211 24.0009V15.5634H7.07609V12.0744H10.1241V9.41193C10.1241 6.38643 11.9166 4.71543 14.6571 4.71543C15.9711 4.71543 17.3436 4.95093 17.3436 4.95093V7.92093H15.8301C14.3406 7.92093 13.8756 8.85243 13.8756 9.80793V12.0729H17.2026L16.6716 15.5619H13.8741V23.9994C19.6101 23.0934 23.9991 18.0984 23.9991 12.0729Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3671_10344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4eac7be5.svg";
export { ForwardRef as ReactComponent };